import CompLayout from "@/pcomponents/comp/layout/layout";
import UseListArea from "@/pages/comp/edu/desk/common/use_list";

function ListPage(){
  return (
    <CompLayout isConTitle={false}>
      <UseListArea></UseListArea>
    </CompLayout>
  );
}

export default ListPage;